if (!customElements.get('moody-bundle-builder')) {
  customElements.define(
    'moody-bundle-builder',
    class MoodyBundleBuilder extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.error = this.querySelector('[data-bundle-error]');
        this.submit = this.querySelector('[data-bundle-submit]');
        this.addLabel = this.querySelector('[data-submit-label]');
        this.addingLabel = this.querySelector('[data-adding-label]');
        this.choices = { first: null, second: null, gift: null };

        this.querySelectorAll('[data-product-choice]').forEach((button) => {
          button.addEventListener('click', () => this.selectProduct(button));
        });

        this.submit?.addEventListener('click', () => this.addBundle());
      }

      selectProduct(button) {
        const group = button.dataset.productChoice;
        const key = button.dataset.productKey;

        this.querySelectorAll(`[data-product-choice="${group}"]`).forEach((item) => {
          item.setAttribute('aria-pressed', String(item === button));
        });

        this.querySelectorAll(`[data-variant-panel="${group}"]`).forEach((panel) => {
          panel.hidden = panel.dataset.productKey !== key;
        });

        this.choices[group] = key;
        this.hideError();
      }

      selectedVariant(group) {
        const key = this.choices[group];
        if (!key) return '';
        return this.querySelector(`[data-variant-panel="${group}"][data-product-key="${key}"] [data-variant-select]`)?.value || '';
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
        this.error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      hideError() {
        this.error.hidden = true;
        this.error.textContent = '';
      }

      setLoading(loading) {
        this.submit.disabled = loading;
        this.addLabel.hidden = loading;
        this.addingLabel.hidden = !loading;
      }

      createBundleId() {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
        return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      }

      async addBundle() {
        this.hideError();
        const firstVariant = this.selectedVariant('first');
        const secondVariant = this.selectedVariant('second');
        const giftVariant = this.selectedVariant('gift');

        if (!firstVariant || !secondVariant || !giftVariant) {
          this.showError(this.dataset.selectionRequired);
          return;
        }

        this.setLoading(true);

        try {
          const cartResponse = await fetch(this.dataset.cartJsonUrl, {
            headers: { Accept: 'application/json' }
          });

          if (!cartResponse.ok) throw new Error('cart-read-failed');

          const cart = await cartResponse.json();
          const alreadyHasBundle = cart.items?.some(
            (item) => item.properties?._Bundle_offer === 'glowy-2plus1-half-free-v1'
          );

          if (alreadyHasBundle) {
            this.showError(this.dataset.limitOneError);
            this.setLoading(false);
            return;
          }
        } catch (error) {
          this.showError(this.dataset.addError);
          this.setLoading(false);
          return;
        }

        const bundleId = this.createBundleId();
        const commonProperties = {
          _Bundle: 'GlowyLock Trial Bundle',
          _Bundle_id: bundleId,
          _Bundle_offer: 'glowy-2plus1-half-free-v1'
        };
        const items = [
          {
            id: firstVariant,
            quantity: 1,
            properties: { ...commonProperties, _Bundle_role: 'First GlowyLock', _Bundle_discount_role: 'first' }
          },
          {
            id: secondVariant,
            quantity: 1,
            properties: { ...commonProperties, _Bundle_role: 'Second GlowyLock', _Bundle_discount_role: 'second' }
          },
          {
            id: giftVariant,
            quantity: 1,
            properties: { ...commonProperties, _Bundle_role: 'Free Trial', _Bundle_discount_role: 'trial' }
          }
        ];

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items
            })
          });

          if (!response.ok) throw new Error('cart-add-failed');
          window.location.assign(this.dataset.discountUrl);
        } catch (error) {
          this.showError(this.dataset.addError);
          this.setLoading(false);
        }
      }
    }
  );
}
